import gsap from "gsap"
import { module as BaseModule } from "modujs"
import Swiper from "swiper"
import { Keyboard, Navigation } from "swiper/modules"

import "swiper/css"
import "swiper/css/keyboard"
import "swiper/css/navigation"

export default class extends BaseModule {
  init() {
    const slider = this.el
    const { sliderConfig } = slider.dataset
    const _this = this

    const params = {
      default: {
        modules: [Keyboard, Navigation],
        draggable: true,
        slidesPerView: 1,
        grabCursor: true,
        centeredSlides: this.isPressPage() ? false : true,
        loop: this.isPressPage() ? false : true,
        navigation: {
          nextEl: "[data-slider-next]",
          prevEl: "[data-slider-prev]",
        },
        keyboard: {
          enabled: true,
          onlyInViewport: false,
        },
        breakpoints: {
          1024: {
            slidesPerView: "auto",
            spaceBetween: 16,
          },
        },
        on: {
          slideChange: (instance) => {
            _this.onPressSlideChange(instance)
          },
          init: (instance) => {
            _this.onInit(instance)
            _this.onPressInit(instance)
          },
        },
      },
    }

    if (window.matchMedia("(max-width: 1024px)").matches) {
      this.removeFillerSlides()
    }

    setTimeout(() => {
    this.swiper = new Swiper(slider, params[sliderConfig])
  }, 100)

    gsap.to(slider, {
      opacity: 1,
      duration: 3,
      ease: "power2.Out",
    })
  }

  isPressPage() {
    return this.el
    && this.el.getAttribute("data-press-page") === "true"
  }

  onPressSlideChange(instance) {
    if (!this.isPressPage()) {
      return
    }
    
    const articleDates = document.querySelectorAll("[data-press-article-date]")
    const activeSlide = instance.slides[instance.activeIndex]
    const date = activeSlide.getAttribute("data-date")
    articleDates.forEach((element) => {
      element.innerHTML = date
    })
  
    const yearBtns = document.querySelectorAll("[data-btn-year]")
    yearBtns.forEach((btn) => {
      const year = btn.getAttribute("data-btn-year")
      btn.classList.toggle("text-lightgray", year === date)
    })
  }

   onInit(instance) {
    const slides = instance.slides
    slides.forEach((slide) => {
      if (slide.dataset.filler === "true") {
        return
      }
  
      const modalIndex = slide.getAttribute("data-modal-index")
      if (modalIndex === null) {
        return
      }
  
      slide.addEventListener("click", () => {
        const event = new CustomEvent("clickSliderThumbnail", {
          detail: { index: parseInt(modalIndex, 10) },
        })
        document.dispatchEvent(event)
      })
    })
  }

  onPressInit(instance) {
    if (!this.isPressPage()) {
      return
    }
  
    let yearsIndex = []
    try {
      yearsIndex = JSON.parse(this.el.dataset.index || "[]")
    } catch (error) {
      yearsIndex = []
    }
  
    const yearBtns = document.querySelectorAll("[data-btn-year]")
    if (yearBtns[0]) {
      yearBtns[0].classList.add("text-lightgray")
    }
  
    yearBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        const year = +btn.getAttribute("data-btn-year")
        const target = yearsIndex.find((item) => item.year === year)
        if (typeof target?.slideIndex === "number") {
          instance.slideTo(target.slideIndex)
        }
      })
    })
  }
  
  removeFillerSlides() {
    const fillerSlides = document.querySelectorAll("[data-filler]")
    fillerSlides.forEach((slide) => {
      slide.remove()
    })
  }
  
}






